var map = {
	"./100kts.png": [
		7637,
		[
			637
		]
	],
	"./105kts.png": [
		8814,
		[
			814
		]
	],
	"./10kts.png": [
		2177,
		[
			177
		]
	],
	"./110kts.png": [
		6940,
		[
			940
		]
	],
	"./115kts.png": [
		579,
		[
			579
		]
	],
	"./120kts.png": [
		3319,
		[
			319
		]
	],
	"./125kts.png": [
		8027,
		[
			408
		]
	],
	"./130kts.png": [
		9990,
		[
			990
		]
	],
	"./135kts.png": [
		9261,
		[
			261
		]
	],
	"./140kts.png": [
		7825,
		[
			825
		]
	],
	"./145kts.png": [
		546,
		[
			546
		]
	],
	"./150kts.png": [
		3608,
		[
			608
		]
	],
	"./15kts.png": [
		610,
		[
			610
		]
	],
	"./1kts.png": [
		5093,
		[]
	],
	"./20kts.png": [
		6898,
		[
			898
		]
	],
	"./25kts.png": [
		4177,
		[
			558
		]
	],
	"./30kts.png": [
		9427,
		[
			427
		]
	],
	"./35kts.png": [
		7215,
		[
			596
		]
	],
	"./40kts.png": [
		6092,
		[
			92
		]
	],
	"./45kts.png": [
		2275,
		[
			275
		]
	],
	"./50kts.png": [
		133,
		[
			133
		]
	],
	"./55kts.png": [
		6366,
		[
			366
		]
	],
	"./5kts.png": [
		6017,
		[
			17
		]
	],
	"./60kts.png": [
		4518,
		[
			518
		]
	],
	"./65kts.png": [
		8749,
		[
			749
		]
	],
	"./70kts.png": [
		5095,
		[
			95
		]
	],
	"./75kts.png": [
		9096,
		[
			96
		]
	],
	"./80kts.png": [
		7664,
		[
			664
		]
	],
	"./85kts.png": [
		2463,
		[
			463
		]
	],
	"./90kts.png": [
		169,
		[
			169
		]
	],
	"./95kts.png": [
		6298,
		[
			298
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8872;
module.exports = webpackAsyncContext;